export * from "-!../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--6-0!../../node_modules/vue-style-loader/index.js!../../node_modules/css-loader/index.js??ref--6-2!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/lib/index.js??ref--6-3!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AccountDetail.vue?vue&type=style&index=0&id=4b3a50bc&prod&scoped=true&lang=css&"


//////////////////
// WEBPACK FOOTER
// ./src/views/AccountDetail.vue?vue&type=style&index=0&id=4b3a50bc&prod&scoped=true&lang=css&
// module id = 8MwK
// module chunks = 1